var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 98.52 17.38"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M98 17.38H0c33.64 0 66.98-5.89 98.52-17.38-.35 5.78-.52 11.57-.52 17.38z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }